"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environments = void 0;
var Environments;
(function (Environments) {
    Environments[Environments["LOCALHOST"] = 0] = "LOCALHOST";
    Environments[Environments["GOERLI"] = 1] = "GOERLI";
})(Environments = exports.Environments || (exports.Environments = {}));
